import Panel, { PanelProps } from '../Panel';

export type AccordionPanelProps = PanelProps;

export default Panel;
